import { render } from "./TermosCondicoes.vue?vue&type=template&id=8bfd344a&scoped=true"
import script from "./TermosCondicoes.vue?vue&type=script&lang=js"
export * from "./TermosCondicoes.vue?vue&type=script&lang=js"

import "./TermosCondicoes.vue?vue&type=style&index=0&id=8bfd344a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bfd344a"]])

export default __exports__